import React from "react";
import { Spin } from "../../components/BP2Components";
import { useImage } from "@util/customHooks";

const LogoImage = ({ src, alt, style = null, ...rest }) => {
   const { loading, error, image } = useImage(src);

   if (error) return <p>{alt}</p>;

   return (
      <>
         {loading ? (
            <div className="spin-middle">
               <Spin />
            </div>
         ) : (
            <img alt={alt} style={style} src={image} {...rest} />
         )}
      </>
   );
};

export default LogoImage;
